module.exports = __webpack_public_path__ + "static/media/it-consulting.ac4c27c9.svg";